import { render, staticRenderFns } from "./GroupPieces.vue?vue&type=template&id=0779aa1c&scoped=true"
import script from "./GroupPieces.vue?vue&type=script&lang=js"
export * from "./GroupPieces.vue?vue&type=script&lang=js"
import style0 from "./GroupPieces.vue?vue&type=style&index=0&id=0779aa1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0779aa1c",
  null
  
)

export default component.exports